export const ACCESS_TOKEN = 'access_token';
export const THEME_REDIRECTED = 'theme_redirected';
export const I18N_REDIRECTED = 'i18n_redirected';
export const PUSH_API_STATUS = 'push_api_status';
export const ORDER_EMAIL = 'orderEmail';
export const SENDER_ID = 'senderId';
